/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { getBoxShadowStyle } from '@styles/shadow';
import Svg from '@styles/icons/svg';

import TouchableElement from '@components/common/touchableElement';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { SimpleOnPress } from '@interfaces/base';
import { ColorFunction } from '@styles/colors/types';

const LineButton = ({
  C,
  onPress,
  onAdditionalBtnPress,
  height = 42,
  borderBottom = false,
  shadow = true,
  borderRadiusTop = true,
  borderRadiusBottom = true,
  bg = 'Background / Light / Field',
  fontTitle: customFontTitle,
  fontText: customFontText,
  title,
  text,
  additionalBtnIcon,
  additionalBtnColor,
  scale = initialScale,
  font = initialFont,
}: Partial<SimpleOnPress> & {
  C: ColorFunction;
  onAdditionalBtnPress?: () => void;
  height?: number;
  borderBottom?: boolean;
  shadow?: boolean;
  borderRadiusTop?: boolean;
  borderRadiusBottom?: boolean;
  bg?: string;
  imgBg?: string;
  fontTitle?: string;
  fontText?: string;
  title?: string | null;
  text?: string | null;
  additionalBtnIcon?: string;
  additionalBtnColor?: string;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}) => {
  return (
    <View
      style={[
        { height: scale(height), userSelect: 'none' },
        shadow && {
          borderRadius: scale(SCREEN_BORDER_RADIUS),
        },
        shadow && getBoxShadowStyle({ type: 'Field', C }),
        borderBottom && {
          borderBottomColor: C('Hairline/Light/No trans'),
          borderBottomWidth: StyleSheet.hairlineWidth,
        },
      ]}
    >
      <TouchableElement onPress={onPress} hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              {
                backgroundColor: C(pressHoverColor(bg)),
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignContent: 'center',
              },
              borderRadiusTop && {
                borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              borderRadiusBottom && {
                borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              boxStyle,
            ]}
          >
            <View style={{ flexDirection: 'row', paddingHorizontal: scale(15) }}>
              <View style={{ paddingVertical: scale(8), flex: 1 }}>
                <Text numberOfLines={1} style={[font[customFontTitle || 'Headline'], { color: C('Label/Light/Primary'), height: scale(22) }]}>
                  {title}
                </Text>
                <Text numberOfLines={1} style={[font[customFontText || 'Subhead 2'], { color: C('Label/Light/Secondary'), height: scale(22) }]}>
                  {text}
                </Text>
              </View>
              <View style={{ height: '100%', flexDirection: 'row', alignSelf: 'flex-end', alignItems: 'center', gap: scale(10) }}>
                {onAdditionalBtnPress && additionalBtnIcon ? (
                  <TouchableElement onPress={onAdditionalBtnPress}>
                    {({ boxStyle }) => (
                      <View style={[boxStyle]}>
                        <Svg icon={additionalBtnIcon} color={additionalBtnColor} height={16} width={16} />
                      </View>
                    )}
                  </TouchableElement>
                ) : (
                  <Svg icon="chevronRightLight" height={scale(11)} width={scale(7)} color={'Label / Light / Secondary'} />
                )}
              </View>
            </View>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default LineButton;
